export default __webpack_public_path__ + "static/media/Bangalore.498eb8cf.webp";